export default __webpack_public_path__ + "static/media/laurels.e7608286.png";